import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Douae = () => {
  const { id } = useParams();
  const [hasEntered, setHasEntered] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [inputKey, setInputKey] = useState("");
  const [error, setError] = useState(false);

  const SECRET_KEY = "bzizila"; // Change this to your desired password
  const message = id ? id.replace(/-/g, " ") : "In a universe of infinite variables, you are my only constant.";

  const handleVerify = () => {
    if (inputKey.toLowerCase() === SECRET_KEY.toLowerCase()) {
      setIsAuthorized(true);
      setError(false);
    } else {
      setError(true);
      setInputKey("");
    }
  };

  const stats = [
    { label: "Heartbeat", value: "Syncing...", icon: "ecg_heart", color: "text-secondary", border: "border-secondary/50" },
    { label: "Connection", value: "Eternal", icon: "all_inclusive", color: "text-primary", border: "border-primary/50" },
    { label: "Memory Usage", value: "Douae only", icon: "memory", color: "text-purple-400", border: "border-purple-500/50" }
  ];

  return (
    <div className="h-screen w-full bg-[#020617] text-white relative overflow-hidden font-display nebula-intense-bg flex flex-col items-center justify-center">
      <div className="fixed inset-0 z-0 pointer-events-none opacity-40 bg-grid-pattern"></div>

      <AnimatePresence mode="wait">
        {!hasEntered ? (
          <motion.main
            key="gatekeeper"
            initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 1.1 }}
            className="relative z-10 w-full flex flex-col items-center justify-center p-6 text-center"
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-12 glow-text tracking-tighter uppercase max-w-2xl leading-none">
              Do you really want to go there?
            </h1>
            <div className="flex gap-6 w-full max-w-md">
              <button onClick={() => setHasEntered(true)} className="flex-1 py-4 bg-primary hover:bg-purple-400 rounded-xl font-bold text-sm shadow-[0_0_20px_rgba(238,43,173,0.4)] transition-all">Yes</button>
              <Link to="/" className="flex-1 py-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl font-bold text-sm text-center transition-all">Back Home</Link>
            </div>
          </motion.main>
        ) : !isAuthorized ? (
          <motion.main
            key="auth"
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
            className="relative z-10 w-full flex flex-col items-center justify-center p-6 text-center"
          >
            <div className="ui-card p-8 max-w-md w-full border-white/10 bg-black/40 backdrop-blur-xl">
              <h2 className="text-2xl font-bold mb-2 uppercase tracking-tight">Authorization Required</h2>
              <p className="text-slate-400 text-xs font-mono mb-6 uppercase tracking-widest">Enter Access Key to Decrypt</p>

              <div className="space-y-4">
                <input
                  type="password"
                  value={inputKey}
                  onChange={(e) => setInputKey(e.target.value)}
                  placeholder="_ _ _ _ _ _"
                  className={`w-full bg-black/50 border ${error ? 'border-red-500' : 'border-white/10'} rounded-lg py-3 px-4 text-center font-mono tracking-[0.5em] focus:outline-none focus:border-primary/50 transition-all`}
                  onKeyDown={(e) => e.key === 'Enter' && handleVerify()}
                />
                {error && <p className="text-red-500 text-[10px] font-mono uppercase tracking-tighter">Access Denied. Invalid Key.</p>}
                {!error && <p className="text-slate-500/50 text-[10px] font-mono tracking-widest hover:text-pink-400 transition-colors cursor-help">Hint: boobs hhhh</p>}

                <button
                  onClick={handleVerify}
                  className="w-full py-3 bg-secondary hover:bg-pink-400 text-white rounded-lg font-bold text-xs uppercase tracking-widest transition-all"
                >
                  Verify Identity
                </button>
                <button onClick={() => setHasEntered(false)} className="text-slate-500 text-[10px] uppercase font-mono hover:text-white transition-colors">Return</button>
              </div>
            </div>
          </motion.main>
        ) : !isAccepted ? (
          <motion.main
            key="transmission"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="relative z-10 w-full flex flex-col items-center justify-center p-6"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-10 glow-text tracking-tighter uppercase">Cosmic Connection Established</h1>
            <div className="ui-card max-w-5xl w-full p-6 md:p-8 flex flex-col md:flex-row gap-8 items-stretch bg-black/40 backdrop-blur-xl border-white/10">
              <div className="w-full md:w-1/2 aspect-video md:aspect-auto rounded-xl overflow-hidden relative border border-white/10">
                <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1464802686167-b939a6910659?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#020617] to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-left">
                  <p className="text-primary font-mono text-[10px] uppercase tracking-widest flex items-center gap-1">
                    <span className="material-symbols-outlined !text-xs">favorite</span> Target Locked
                  </p>
                  <p className="text-xl font-bold">Douae</p>
                </div>
              </div>
              <div className="w-full md:w-1/2 flex flex-col justify-center space-y-4 text-left">
                <div className="border-l-2 border-primary/50 pl-4">
                  <p className="text-slate-400 text-[10px] font-mono uppercase tracking-widest">Incoming Transmission</p>
                  <h3 className="text-2xl font-bold">Message for Douae</h3>
                </div>
                <div className="bg-black/40 rounded-xl p-5 border border-white/5 font-mono text-xs leading-relaxed text-slate-300">
                  <p className="text-secondary/70 mb-2">{`>> decrypting message...`}</p>
                  <p className="text-slate-100 italic">"{message}"</p>
                </div>
                <div className="flex gap-4">
                  <button onClick={() => setIsAccepted(true)} className="flex-1 py-3 bg-primary hover:bg-pink-400 rounded-xl font-bold text-xs transition-all">Accept Signal</button>
                  <button onClick={() => setIsAuthorized(false)} className="flex-1 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl font-bold text-xs transition-all">Abort</button>
                </div>
              </div>
            </div>
          </motion.main>
        ) : (
          <motion.main
            key="synchronized"
            initial={{ opacity: 0, scale: 1.05 }} animate={{ opacity: 1, scale: 1 }}
            className="relative z-10 w-full flex flex-col items-center justify-center p-6 space-y-8"
          >
            <div className="text-center space-y-2">
              <h1 className="text-5xl md:text-7xl font-bold glow-text-blue tracking-tighter uppercase leading-none">SIGNAL SYNCHRONIZED</h1>
              <p className="text-slate-400 font-mono text-xs tracking-widest uppercase opacity-70">// Connection Established with User: DOUAE</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center w-full max-w-4xl">
              <div className="flex justify-center relative">
                <svg className="w-64 h-64 constellation-heart animate-float" viewBox="0 0 200 200">
                  <path d="M100 170 L50 120 L20 80 L50 40 L100 70 L150 40 L180 80 L150 120 Z" stroke="#0ea5e9" strokeWidth="1" strokeOpacity="0.5" fill="none" />
                  <circle cx="100" cy="170" r="4" fill="#ee2bad" className="animate-pulse" />
                  <circle cx="50" cy="120" r="3" fill="#0ea5e9" />
                  <circle cx="150" cy="120" r="3" fill="#0ea5e9" />
                  <circle cx="20" cy="80" r="3" fill="#0ea5e9" />
                  <circle cx="180" cy="80" r="3" fill="#0ea5e9" />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="w-48 h-48 border border-secondary/10 rounded-full animate-[spin_20s_linear_infinite]"></div>
                </div>
              </div>

              <div className="ui-card p-6 md:p-8 bg-black/60 border-white/10 relative rounded-2xl overflow-hidden">
                <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-secondary/50 rounded-tl-lg"></div>
                <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-primary/50 rounded-br-lg"></div>

                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-bold flex items-center gap-2">
                    <span className="material-symbols-outlined text-secondary fill-1">assignment_turned_in</span>
                    Affection Report
                  </h3>
                  <span className="text-[9px] font-mono text-green-400 bg-green-500/10 px-2 py-0.5 rounded border border-green-500/20">SUCCESS</span>
                </div>

                <div className="space-y-5">
                  <div>
                    <div className="flex justify-between text-[9px] font-mono mb-1.5 text-slate-400"><span>COMPATIBILITY</span><span>100%</span></div>
                    <div className="w-full bg-white/5 h-1.5 rounded-full overflow-hidden border border-white/5">
                      <div className="bg-gradient-to-r from-secondary to-primary h-full w-full"></div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="bg-white/5 p-3 rounded-lg border border-white/5">
                      <p className="text-[9px] text-slate-500 font-mono uppercase">Status</p>
                      <p className="text-white text-sm font-bold">Locked In</p>
                    </div>
                    <div className="bg-white/5 p-3 rounded-lg border border-white/5">
                      <p className="text-[9px] text-slate-500 font-mono uppercase">Duration</p>
                      <p className="text-white text-sm font-bold">Infinity</p>
                    </div>
                  </div>
                  <div className="bg-primary/5 p-4 rounded-lg border border-primary/20">
                    <p className="text-primary font-mono text-[11px] italic leading-relaxed text-center">
                      "Successfully compiled feelings for Douae. No bugs found. Deployment to heart successful."
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-4xl">
              {stats.map((stat, i) => (
                <div key={i} className={`ui-card p-3 text-center border-t-2 ${stat.border} bg-white/5`}>
                  <p className={`${stat.color.replace('text-', 'text-')}/70 text-[9px] font-mono uppercase mb-1`}>{stat.label}</p>
                  <div className="flex items-center justify-center gap-2">
                    <span className={`material-symbols-outlined !text-sm ${stat.color} ${stat.icon === 'ecg_heart' ? 'animate-pulse' : ''}`}>{stat.icon}</span>
                    <span className="text-white font-bold text-sm">{stat.value}</span>
                  </div>
                </div>
              ))}
            </div>

            <button onClick={() => { setIsAccepted(false); setIsAuthorized(false); setHasEntered(false); }} className="px-8 py-2.5 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full text-xs font-bold transition-all flex items-center gap-2">
              <span className="material-symbols-outlined !text-sm">arrow_back</span> Return to Orbit
            </button>
          </motion.main>
        )}
      </AnimatePresence>
      <p className="absolute bottom-4 z-10 text-[9px] font-mono text-slate-600 tracking-widest mt-auto">// ENCRYPTED WITH LOVE FOR DOUAE • VERSION 1.0.7</p>
    </div>
  );
};

export default Douae;